'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_Img_Img = require('../../display/Img/Img.cjs.js');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = styleEncapsulation.labelStyles("OneColumnBlock", {
  root: (backgroundColor = "neutral100") => [
    react.css`
      ${styleMixins_reset.boxSizing};
      background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};
      padding: 20px;
      @media screen and (min-width: ${breakpoints.tablet}px) {
        padding: 40px 30px;
      }
      @media screen and (min-width: ${breakpoints.desktop}px) {
        padding: 50px 30px;
      }
    `
  ],
  content: [
    react.css`
      ${styleMixins_reset.boxSizing};
      margin: 0 auto;
      text-align: center;
      max-width: 1170px;
    `
  ],
  text: (textAlign) => react.css`
    ${styleMixins_reset.boxSizing};
    text-align: ${textAlign};
    max-width: 720px;
    margin-left: ${textAlign === "center" || textAlign === "right" ? "auto" : 0};
    margin-right: ${textAlign === "center" ? "auto" : 0};
  `,
  headingContainer: [
    react.css`
      ${styleMixins_reset.boxSizing};
      ${theme_LegacyTypography.LegacyTypography.pageHeader5}

      @media screen and (min-width: ${breakpoints.desktop}px) {
        ${theme_LegacyTypography.LegacyTypography.pageHeader5}
      }
    `
  ],
  description: [
    react.css`
      ${styleMixins_reset.boxSizing};
      margin-top: 20px;
      ${theme_LegacyTypography.LegacyTypography.smallPrint1}
      color: ${theme_Colors.Colors.GrayWarm9};

      @media screen and (min-width: ${breakpoints.tablet}px) {
        ${theme_LegacyTypography.LegacyTypography.paragraph1Short}
      }
    `
  ]
});
const OneColumnBlock = ({ backgroundColor, altText = "", headingTag = "h3", heading, description, imageUrl, textAlign = "center" }) => {
  return react.jsx(
    "div",
    { css: Styles.root(backgroundColor), "data-zds": true },
    react.jsx("div", { css: Styles.content }, imageUrl ? react.jsx(components_display_Img_Img.Img, { borderRadius: "none", src: imageUrl, alt: altText }) : react.jsx(
      "div",
      { "data-testid": "Text", css: Styles.text(textAlign), "data-zds": true },
      react.jsx(
        "div",
        { css: Styles.headingContainer, "data-zds": true },
        react.jsx(components_display_Text_Text.Text, { type: "heading", color: "GrayWarm10", tag: headingTag }, heading)
      ),
      description && react.jsx("div", { css: Styles.description, "data-zds": true }, description)
    ))
  );
};

exports.OneColumnBlock = OneColumnBlock;
//# sourceMappingURL=OneColumnBlock.cjs.js.map
